const getUrl = (): string => location.href;

export { getUrl };
